<template>
  <div>
    <v-dialog max-width="400" height="30" hide-overlay v-model="noDetailsCard">
      <v-card fluid grid-list color="#88D2FA">
        <!-- This layout below is for the information fields. -->
        <v-layout row wrap>
          <v-card-title class="pa-2">
            <v-icon class="closeEventCard" @click="noDetailsCard = false">close</v-icon>
          </v-card-title>
          <v-card-text>
          <h2>{{$translate('CQ_ORDERDETAILS')}}</h2>
          <p>{{$translate('CQ_EXT_EVE_INFO')}}</p>
          </v-card-text>
            <v-flex xs5 offset-xs1>
              <h3>{{$translate('EVENT_START_DATE')}}</h3>
              <p class="newFontSize">{{currentEvent.startDate}}</p>
            </v-flex>
            <v-flex xs5 offset-xs1>
              <h3>{{$translate('EVENT_END_DATE')}}</h3>
              <p class="newFontSize">{{ currentEvent.endDate }}</p>
            </v-flex>
          <v-flex xs5 offset-xs1>
          <h3>{{$translate('EVENT_START_TIME')}}</h3>
          <p class="newFontSize">{{currentEvent.startTime}}</p>
        </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('EVENT_END_TIME')}}</h3>
            <p class="newFontSize">{{ currentEvent.endTime }}</p>
          </v-flex>
        </v-layout>
        <v-layout align-content-center row wrap>
          <v-flex xs12>
            <v-card class="elevation-0" color="#88D2FA">
              <v-divider/>
              <h3 class="cardTitle ma-0 pa-2">{{currentEvent.Source}}</h3>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="eventCard"
      max-width="400"
      max-height="300px"
      persistent
      hide-overlay
      class="overflow-hidden"
    >
      <v-card>
      </v-card>
      <v-card fluid grid-list color="#88D2FA">
        <!-- This layout below is for the information fields. -->
        <v-layout row wrap>
          <v-card-title class="pa-2">
            <v-icon class="closeEventCard" @click="eventCard = false">close</v-icon>
          </v-card-title>
          <v-card-text>
            <h2>{{$translate('CQ_USER_DETAILS')}}</h2>
          </v-card-text>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('USERNAME')}}</h3>
            <p class="newFontSize">{{ currentEvent.userName }}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('PHONE_NR')}}</h3>
            <p class="newFontSize">{{ currentEvent.userPhoneNumber }}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('REGISTER_FORM_EMAIL')}}</h3>
            <a
              class="newFontSize"
              :href="'mailto:' + currentEvent.userEmail"
            >
              {{currentEvent.userEmail}}
            </a>
          </v-flex>
          <v-card-text>
            <h2 class="mt-2">{{$translate('ORDER_DETAILS')}}</h2>
          </v-card-text>
          <v-flex xs5 offset-xs1>
            <h3 >{{$translate('EVENT_START_DATE')}}</h3>
            <p class="newFontSize">{{currentEvent.startDate}}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('EVENT_END_DATE')}}</h3>
            <p class="newFontSize">{{ currentEvent.endDate }}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('EVENT_START_TIME')}}</h3>
            <p class="newFontSize">{{currentEvent.startTime}}</p>
          </v-flex>
          <v-flex xs5 offset-xs1>
            <h3>{{$translate('EVENT_END_TIME')}}</h3>
            <p class="newFontSize">{{ currentEvent.endTime }}</p>
          </v-flex>
        </v-layout>
        <v-card class="elevation-0 transparent">
        <v-layout row justify-center align-center class="pa-4">
          <a @click="showOrderPdf()"><b>Download order pdf <v-icon small>get_app</v-icon></b></a>
        </v-layout>
        </v-card>
        <v-layout justify-center row wrap>
          <v-flex xs12 >
            <v-card class="elevation-0 transparent">
              <v-layout row justify-center>
                <qrcode class="mb-2" :value="currentEvent.OrderId" :options="{ width: 100 }"/>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout align-content-center row wrap>
          <v-flex xs12>
            <v-card class="elevation-0" color="#88D2FA">
              <v-divider/>
              <h3 class="cardTitle ma-0 pa-2">{{currentEvent.OrderId}}</h3>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!--this flex is used to show the month calendar-->
    <v-flex v-if="type === 'month'" id="month" class="mt-2 pa-0 mb-5 pb-3">
      <OperationalScreen_QuadrantToolbar
        :componentId="properties.componentId"
        :headers="headers"
        :title="productCalendarTitle"
        :toolBarOptions="false"
        class="quadrant"
        :toolBarCalendarInfo="true"
      />
      <v-sheet class="calendar">
        <v-calendar
          ref="calendar"
          :now="today"
          v-model="month"
          :value="today"
          width="344px"
          :type="type"
          color="primary"
          class="scrollingPossible"
          :interval-format="intervalFormat"
        >
          <!--events in month view dont look at time because its not relevant-->
          <template v-slot:day="{ date }">
            <template v-for="event in eventsMap[date]">
              <v-menu
                :key="event.title"
                v-model="event.open"
                full-width
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <!--if else to make BLOCKED dates have icon-->
                  <div
                    v-if="event.Source === '' "
                    v-ripple
                    class="my-event"
                    :style="`background-color: ${event.color}; border-color: ${event.color}`"
                    v-on="on"
                    @click="getOrderById(event)"
                  >
                    <v-icon class="info-icon" color="gray" small>info</v-icon>
                  </div>
                  <div
                    v-if="event.Source !== '' "
                    v-ripple
                    class="my-event"
                    :style="`background-color: #a6a6a6; border-color: #a6a6a6`"
                    v-html="event.title"
                    @click="noDetailsCard = true; getOrderById(event)"
                  >
                  </div>
                  <div
                    v-if="event.title === 'BLOCKED'"
                    v-ripple
                    class="my-event"
                    :style="`background-color: ${event.color}; border-color: ${event.color}`"
                    v-on="on"
                  >
                    <v-icon dark small>block</v-icon>
                  </div>
                </template>
              </v-menu>
            </template>
          </template>
        </v-calendar>
        <!--this is the toolbar at the bottom of the calendar-->
        <v-toolbar>
          <v-btn @click="switchToWeek()" class="viewButton">{{$translate('CQ_WEEK_VIEW')}}</v-btn>
          <v-tooltip top>
            <!--this is the options button-->
            <!--to choose between block dates and create booking-->
            <v-menu slot="activator">
              <v-toolbar-side-icon
                disabled
                class="options"
                slot="activator"
              />
              <!--this is the form for creating a new booking-->
              <v-card>
                <div class="buttons">
                  <v-card-text>Create booking or block date range:</v-card-text>
                  <v-dialog v-model="dialogCB" max-width="290" max-height="300px" persistent>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark v-on="on">Create Booking</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Booking Info</span>
                      </v-card-title>
                      <p class="subHeader">All fields are required</p>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs6 sm6 md4>
                            <v-text-field
                              slot="activator"
                              v-model="name"
                              label="Name"
                              required
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              slot="activator"
                              label="Phone Number"
                              v-model="phoneNumber"
                              required
                            />
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              slot="activator"
                              v-model="email"
                              label="Email"
                              required
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="startTimeCB"
                              label="Start time"
                              type="time"
                              v-on="on"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="endTimeCB"
                              label="End time"
                              type="time"
                              v-on="on"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-menu>
                              <v-text-field
                                slot="activator"
                                label="Start date"
                                :value="dateStartCB"
                              />
                              <v-date-picker
                                v-model="dateStartCB"
                                current="false"
                              />
                            </v-menu>
                          </v-flex>
                          <v-spacer/>
                          <v-flex xs6>
                            <v-menu>
                              <v-text-field
                                slot="activator"
                                label="End date"
                                :value="dateEndCB"
                              />
                              <v-date-picker
                                v-model="dateEndCB"
                                current="false"
                              />
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="clearForm()">Close</v-btn>
                        <v-btn color="blue darken-1" flat @click="addBooking()">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!--this is the form to block a date range-->
                  <v-dialog v-model="dialogBD" persistent max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark v-on="on">Block dates</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>Select a start and en date.</v-card-title>
                      <div class="buttonsBD">
                        <v-menu>
                          <v-text-field slot="activator" label="Start date" :value="dateStartBD"/>
                          <v-date-picker v-model="dateStartBD" current="false"/>
                        </v-menu>
                        <v-spacer></v-spacer>
                        <v-menu>
                          <v-text-field slot="activator" label="End date" :value="dateEndBD"/>
                          <v-date-picker v-model="dateEndBD" :show-current="false"/>
                        </v-menu>
                        <v-flex xs6>
                          <v-text-field type="time" label="Start time" :value="startTimeBD"/>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field type="time" label="End time" :value="endTimeBD"/>
                        </v-flex>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="dialogBD = false">Close</v-btn>
                      <v-btn color="blue darken-1" flat @click="addBlockedDates()">Save</v-btn>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card>
            </v-menu>
            <span>Create booking or block dates</span>
          </v-tooltip>
          <!--these are the buttons to go forward/backwords 1 month-->
          <v-btn
            fab
            outline
            small
            absolute
            left
            color="primary"
            @click="$refs.calendar.prev()"
          >
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            outline
            small
            absolute
            right
            color="primary"
            @click="$refs.calendar.next()"
          >
            <v-icon dark>
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
    </v-flex>
    <!--this flex is used to show the week calendar-->
    <v-flex v-else id="week" class="mt-2 pa-0 mb-5 pb-3">
      <OperationalScreen_QuadrantToolbar
        :componentId="properties.componentId"
        :headers="headers"
        :title="productCalendarTitle"
        :toolBarOptions="false"
        class="quadrant"
        :toolBarCalendarInfo="true"
      />
      <v-sheet class="calendar">
        <v-calendar
          ref="calendar"
          v-model="month"
          :value="today"
          :now="today"
          color="primary"
          :type="type"
          interval-minutes="30"
          interval-count="48"
          :interval-format="intervalFormat"
        >
          <!-- the events at the top (all-day) -->
          <template v-slot:dayHeader="{ date }">
            <template v-for="event in eventsMap[date]">
              <!-- all day events don't have time -->
              <v-menu
                :key="event.title"
                v-model="event.open"
                full-width
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    v-if="!event.time && event.Source === '' "
                    :key="event.title"
                    :style="`background-color: ${event.color}; border-color: ${event.color}`"
                    class="my-event"
                    v-ripple
                    v-html="event.title"
                    @click="getOrderById(event)"
                  />
                  <div
                    v-on="on"
                    v-if="!event.time && event.Source !== '' "
                    :key="event.title"
                    :style="{background: '#a6a6a6', border: event.border}"
                    class="my-event"
                    v-ripple
                    v-html="event.title"
                    @click="noDetailsCard = true; getOrderById(event)"
                  ></div>
                  <div
                    v-on="on"
                    v-if="!event.time && event.title === 'BLOCKED'"
                    :key="event.title"
                    :style="`background-color: ${event.color}; border-color: ${event.color}`"
                    class="my-event"
                    v-ripple
                    @click="getOrderById(event);"
                  >
                    <v-icon dark small>block</v-icon>
                  </div>
                </template>
                <!--this is the card you see when you click on an event-->
              </v-menu>
            </template>
          </template>
          <!-- the events at the bottom (timed) -->
          <template v-slot:dayBody="{date, timeToY, minutesToPixels}">
            <template v-for="event in eventsMap[date]">
              <!-- timed events -->
              <v-menu
                :key="event.title"
                v-model="event.open"
                offset-x
              >

                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    v-if="event.time && event.title !== 'BLOCKED'"
                    :key="event.title"
                    :style="{
                    top: timeToY(event.time) + 'px',
                    height: minutesToPixels(event.duration) + 'px'
                  }"
                    v-ripple
                    v-html="event.title"
                    @click="getOrderById(event)"
                    :class="event.duration > 120 ? 'my-event with-time' : 'my-event with-time-large' "
                  />
                  <div
                    v-on="on"
                    v-if="event.time && event.Source !== '' "
                    :key="event.title"
                    :style="{
                    top: timeToY(event.time) + 'px',
                    height: minutesToPixels(event.duration) + 'px',
                    background: '#a6a6a6',
                    border: event.border,
                  }"
                    :class="event.duration > 120 ? 'my-event with-time' : 'my-event with-time-large' "
                    v-ripple
                    v-html="event.title"
                    @click="noDetailsCard = true; getOrderById(event)"
                  ></div>
                  <div
                    v-on="on"
                    v-if="event.time && event.title === 'BLOCKED'"
                    :key="event.title"
                    :style="{
                    top: timeToY(event.time) + 'px',
                    height: minutesToPixels(event.duration) + 'px',
                    width: '30px'
                  }"
                    :class="event.duration > 120 ? 'my-event with-time' : 'my-event with-time-large' "
                    v-ripple
                    @click="getOrderById(event)"
                  >
                    <v-icon dark small>block</v-icon>
                  </div>
                </template>
                <!--the card you see when you click on an event-->
              </v-menu>
            </template>
          </template>
        </v-calendar>
        <!--this is the toolbar at the bottom of the calendar-->
        <v-toolbar>
          <v-btn @click="switchToMonth()" class="viewButton">{{$translate('CQ_MONTH_VIEW')}}</v-btn>
          <!--this is the options button-->
          <!--to choose between block dates and create booking-->
          <v-tooltip top>
            <v-menu slot="activator">
              <v-toolbar-side-icon
                disabled
                class="options"
                slot="activator"
              />
              <v-card>
                <div class="buttons">
                  <!--this is the form for creating a new booking-->
                  <v-card-text>Create booking or block date range:</v-card-text>
                  <v-dialog v-model="dialogCB" max-width="290" max-height="300px" persistent>
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark v-on="on">Create Booking</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Booking Info</span>
                      </v-card-title>
                      <p class="subHeader">All fields are required</p>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs6 sm6 md4>
                            <v-text-field
                              slot="activator"
                              v-model="name"
                              label="Name"
                              required
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              slot="activator"
                              label="Phone Number"
                              v-model="phoneNumber"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              slot="activator"
                              v-model="email"
                              label="Email"
                              required
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="startTimeCB"
                              label="Start time"
                              type="time"
                              v-on="on"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="endTimeCB"
                              label="End time"
                              type="time"
                              v-on="on"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-menu>
                              <v-text-field
                                slot="activator"
                                label="Start date"
                                :value="dateStartCB"
                              />
                              <v-date-picker
                                v-model="dateStartCB"
                                current="false"
                              />
                            </v-menu>
                          </v-flex>
                          <v-spacer/>
                          <v-flex xs6>
                            <v-menu>
                              <v-text-field
                                slot="activator"
                                label="End date"
                                :value="dateEndCB"
                              />
                              <v-date-picker
                                v-model="dateEndCB"
                                current="false"
                              />
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="clearForm()">Close</v-btn>
                        <v-btn color="blue darken-1" flat @click="addBooking()">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!--this is the form to block a date range-->
                  <v-dialog v-model="dialogBD" persistent max-width="350px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark v-on="on">Block dates</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>Select a start and en date.</v-card-title>
                      <div class="buttonsBD">
                        <v-menu>
                          <v-text-field slot="activator" label="Start date" :value="dateStartBD"/>
                          <v-date-picker v-model="dateStartBD" current="false"/>
                        </v-menu>
                        <v-spacer></v-spacer>
                        <v-menu>
                          <v-text-field slot="activator" label="End date" :value="dateEndBD"/>
                          <v-date-picker v-model="dateEndBD" :show-current="false"/>
                        </v-menu>
                        <v-flex xs6>
                          <v-text-field type="time" label="Start time" :value="startTimeBD"/>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field type="time" label="End time" :value="endTimeBD"/>
                        </v-flex>
                      </div>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click="dialogBD = false">Close</v-btn>
                      <v-btn color="blue darken-1" flat @click="addBlockedDates()">Save</v-btn>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card>
            </v-menu>
            <span>Create booking or block dates</span>
          </v-tooltip>
          <!--this is the card you see when you click on an event-->
          <v-btn
            fab
            outline
            small
            absolute
            left
            color="primary"
            @click="$refs.calendar.prev()"
          >
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            outline
            small
            absolute
            right
            color="primary"
            @click="$refs.calendar.next()"
          >
            <v-icon dark>
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
    </v-flex>
  </div>
</template>

<script>
import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import moment from 'moment';
// eslint-disable-next-line camelcase,import/extensions
import OperationalScreen_BaseQuadrant from './OperationalScreen_BaseQuadrant';
// eslint-disable-next-line camelcase,import/extensions
import OperationalScreen_QuadrantToolbar from './OperationalScreen_QuadrantToolbar';
import * as dssRequest from "../../api/dssRequest";

Vue.component(VueQrcode.name, VueQrcode);

export default {
  name: 'OperationalScreen_ProductCalendar',
  extends: OperationalScreen_BaseQuadrant,
  props: {
    boxConfig: {},
    // eventId: String
    // objId: String
  },
  components: {
    OperationalScreen_QuadrantToolbar,
    VueQrcode,
  },
  data: () => ({
    // Mandatory variables
    productId: '',

    timeout: false,
    // CB = Create Booking
    // BD = Block Dates
    events: [],
    dialogBD: false,
    dateStartBD: new Date().toISOString().substr(0, 10),
    dateEndBD: new Date().toISOString().substr(0, 10),
    startTimeBD: '00:00',
    endTimeBD: '23:59',
    dialogCB: false,
    dateStartCB: new Date().toISOString().substr(0, 10),
    dateEndCB: new Date().toISOString().substr(0, 10),
    bookingTime: null,
    name: '',
    email: '',
    phoneNumber: '',
    startTimeCB: '',
    endTimeCB: '',
    productName: '',
    productPhoneNumber: '',
    productEmail: '',
    productOrderId: '',
    eventCard: false,
    noDetailsCard: false,
    productCalendarTitle: '',
    currentEvent: {},
    today: moment().format('YYYY-MM-DD'),
    month: moment().format('YYYY-MM-DD'),
    type: 'month',
    now: null,
    // events: [
    //   {
    //     StartDate: '14-09-2020',
    //     EndDate: '21-09-2020',
    //     StartTime: '09:00',
    //     EndTime: '12:00',
    //     OrderId: 'GR54X21',
    //     UserName: 'Bob',
    //     Email: 'bob@bobdebouwer.nl',
    //     Phone: '0624232120',
    //     Source: 'AirBnB',
    //     locationId: 'L.ABC.000',
    //   },
    //   {
    //     StartDate: '23-09-2020',
    //     EndDate: '25-09-2020',
    //     StartTime: '00:00',
    //     EndTime: '23:59',
    //     OrderId: 'BLOCKED',
    //     UserName: '',
    //     Email: '',
    //     Phone: '',
    //     Source: 'BLOCKED',
    //     locationId: 'L.ABC.000',
    //   },
    //   {
    //     StartDate: '28-09-2020',
    //     EndDate: '28-09-2020',
    //     StartTime: '15:00',
    //     EndTime: '18:00',
    //     OrderId: 'YT04EW1',
    //     UserName: 'Henk',
    //     Email: 'henk@ouwehenkie.nl',
    //     Phone: '0624235423',
    //     Source: '',
    //     locationId: 'L.ABC.000',
    //   },
    // ],
    eventsArray: [],
  }),
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      // eslint-disable-next-line no-return-assign
      this.eventsArray.forEach((event) => (map[event.date] = map[event.date] || []).push(event));
      return map;
    },
    computedFormattedSelectDates() {
      const returnDates = [];
      this.selectDates.forEach((date) => {
        returnDates.push(date.split('-').reverse().join('-'));
      });
      return returnDates;
    },
  },
  mounted() {
    if (this.properties.hasOwnProperty('product')) {
      this.$store.commit("setProductIdForCalendar", this.properties.product);
      this.productId = this.properties.product;
    }
    this.timeout = true;
    this.getProductCalendar();
    this.productCalendarTitle = this.$store.getters.getProductIdForCalendar.Name;
  },
  methods: {
    intervalFormat(interval) {
      return interval.time;
    },
    deleteEvent(event) {
    },
    switchToWeek() {
      this.type = 'week';
      setTimeout(() => {
        this.$refs.calendar.scrollToTime('08:00');
      }, 100)
    },
    switchToMonth() {
      this.type = 'month';
    },
    addBlockedDates() {
      this.eventsArray = [];
      this.events.push({
        StartDate: this.dateStartBD.split('-').reverse().join('-'),
        EndDate: this.dateEndBD.split('-').reverse().join('-'),
        StartTime: '',
        EndTime: '',
        OrderId: 'BLOCKED',
        UserName: '',
        Email: '',
        Phone: '',
        Source: 'BLOCKED',
        locationId: 'L.ABC.000',
      });

      this.dialogBD = false;
      this.getProductCalendar();
    },
    addBooking() {
      this.eventsArray = [];
      this.events.push({
        StartDate: this.dateStartCB.split('-').reverse().join('-'),
        EndDate: this.dateEndCB.split('-').reverse().join('-'),
        StartTime: this.startTimeCB,
        EndTime: this.endTimeCB,
        OrderId: '',
        UserName: this.name,
        Email: this.email,
        Phone: this.phoneNumber,
        Source: '',
        locationId: 'L.ABC.000',
      });

      this.dialogCB = false;
      this.getProductCalendar();
    },
    clearForm() {
      // Clearing the form to start fresh
      this.dialogCB = false;
      this.dateStartCB = new Date().toISOString().substr(0, 10);
      this.dateEndCB = new Date().toISOString().substr(0, 10);
      this.timeCB = '';
      this.name = '';
      this.email = '';
      this.phoneNumber = '';
    },
    getProductCalendar() {
      // Retrieving the productCalendar for the chosen product in OperationalScreen_Main
      const payload = {
        // LocationId to be added
        ProductId: this.productId.Id,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getProductCalendar on OperationalScreen_ProductCalendar was successful',
            response);
          console.log("Laurens this.$store.getters.getProductIdForCalendar", this.$store.getters.getProductIdForCalendar);

          this.interval = true;

          if (response.data.hasOwnProperty('Events')) {
            this.eventsArray = [];
            const responseFromCall = Object.values(response.data.Events);
            const self = this;
            responseFromCall.forEach((arrayItem) => {
              const StartDate = moment(arrayItem.StartDate, 'DD-MM-YYYY');
              const EndDate = moment(arrayItem.EndDate, 'DD-MM-YYYY');
              const Days = EndDate.diff(StartDate, 'days');


              const firstObj = {
                title: arrayItem.OrderId,
                date: moment(StartDate).format('DD-MM-YYYY').split('-').reverse().join('-'),
                days: Days,
                open: false,
                Source: arrayItem.Source,
                time: arrayItem.StartTime,
                startDate: arrayItem.StartDate,
                endDate: arrayItem.EndDate,
                startTime: arrayItem.StartTime,
                endTime: arrayItem.EndTime,
                duration: 2000,
                firstDay: true,
              };

              self.eventsArray.push(firstObj);

              for (let i = 1; i < Days + 1; i++) {
                const mydate = moment(StartDate).add(i, 'day').format('DD-MM-YYYY');

                const myObj = {
                  title: arrayItem.OrderId,
                  date: mydate.split('-').reverse().join('-'),
                  days: Days,
                  open: false,
                  Source: arrayItem.Source,
                  time: null,
                  startDate: arrayItem.StartDate,
                  endDate: arrayItem.EndDate,
                  startTime: arrayItem.StartTime,
                  endTime: arrayItem.EndTime,
                  duration: null,
                  firstDay: false,
                };
                self.eventsArray.push(myObj);
              }
            });

            function findWithAttr(array, attr, value) {
              for (let i = array.length - 1; i >= 0; i -= 1) {
                if (array[i][attr] === value) {
                  return i;
                }
              }
              return 'No ProductId found!';
            }
            this.eventsArray.forEach((event) => {
              // this calculate the time and duration for the first an last day
              const lastDate = findWithAttr(this.eventsArray, 'title', event.title);
              const endTimeDuration = moment.duration(event.endTime).asMinutes();
              const startTimeDuration = moment.duration(event.startTime).asMinutes();
              if (this.eventsArray[lastDate] === event) {
                event.duration = moment.duration(event.endTime).asMinutes();
                if (!event.firstDay) {
                  event.time = '00:00';
                } else {
                  event.duration = endTimeDuration - startTimeDuration;
                }
              }
              // this is to make blocked dates red
              if (event.Source === 'BLOCKED') {
                event.color = 'darkred';
                delete event.time;
                delete event.duration;
                event.title = 'BLOCKED';
              } else {
                event.color = '#1867c0';
              }

              if (event.days > 1) {
                event.border = '2px solid #cccc00';
              }
            });
          } else {
            // Error. No Events received from BE
            console.log("Laurens no events recieved from BE");
          }
          if (this.timeout) {
            this.xTimeInterval();
          }
        },
        (error) => {
          console.log(
            'The generic call getProductCalendar on OperationalScreen_ProductCalendar was not successful',
            error
          );
        },
        'getProductCalendar',
        this.properties.location,
        payload,
      );
    },
    getOrderById(event) {
      this.currentEvent = {};
      this.currentEvent = event;
      const payload = {
        OrderId: event.title,
      };
      if (event.Source === '') {
        dssRequest.doRequest(
          (response) => {
            console.log('The generic call getOrderById was successful', response);

            this.currentEvent.userName = response.data.UserName;
            this.currentEvent.userEmail = response.data.UserEmail;
            this.currentEvent.userPhoneNumber = response.data.UserPhoneNumber;
            this.currentEvent.OrderId = response.data.OrderId;
            this.currentEvent.OrderPdf = "data:application/pdf;base64," + response.data.OrderPdf;
            this.eventCard = true;
          },
          (error) => {
            console.log(
              'The generic call getOrderById was not successful',
              error,
            );
          },
          'getOrderById',
          this.properties.location,
          payload,
        );
      } else {
        return;
      }
    },
    xTimeInterval() {
      setTimeout(this.getProductCalendar, 300000);
    },
    showOrderPdf() {
      // to download the pdf
      const source = this.currentEvent.OrderPdf;
      const downloadLink = document.createElement("a");
      const fileName = "Order" + ".pdf";
      downloadLink.href = source;
      downloadLink.download = fileName;
      downloadLink.click();

      // to open the pdf in new window
      // let pdfWindow = window.open('');
      // pdfWindow.document.write(
      //   "<iframe width='100%' name='text' height='100%' src='data:application/pdf;base64, " +
      //   source + "'></iframe>")
      // pdfWindow.document.title = fileName;
    },
    deleteBlockedDates() {
      console.log("Laurens id", id);

      const payload = {
        OrderId: id,
        ProductId: this.$store.getters.getProductIdForCalendar,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getProducts was successful', response);
          console.log("Laurens you deleted event by id ", response);

        },
        (error) => {
          console.log(
            'The generic call getProducts was not successful',
            error,
          );
        },
        'getProductsV2',
        id.EventId,
        payload,
      );
    },
    saveBlockedDatesInCalendar(id) {
      console.log("Laurens id", id);
      const payload = {
        OrderId: '',
        StartDate: this.dateStartBD,
        EndDate: this.dateEndBD,
        StartTime: this.startTimeBD,
        EndTime: this.endTimeBD,
        ProductId: this.$store.getters.getProductIdForCalendar,
      };
      if (id !== '') {
        payload.OrderId = id;
      } else {
        payload.OrderId = '';
      }
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call saveBlockedDatesInCalendar was successful', response);
        },
        (error) => {
          console.log(
            'The generic call getProducts was not successful',
            error,
          );
        },
        'getProductsV2',
        id.EventId,
        payload,
      );
    },
    // saveBookingDatesInCalendar(id) {
    //   console.log("Laurens id", id);
    //   const payload = {
    //     OrderId: '',
    //     ProductId: this.$store.getters.getProductIdForCalendar,
    //     StartDate: this.dateStartCB,
    //     EndDate: this.dateEndCB,
    //     StartTime: this.startTimeCB,
    //     EndTime: this.endTimeCB,
    //     E-mail: this.email,
    //     Username: this.name,
    //     PhoneNumber: this.phoneNumber,
    //   };
    //   if (id !== '') {
    //     payload.OrderId = id;
    //   } else {
    //     payload.OrderId = '';
    //   }
    //   dssRequest.doRequest(
    //     (response) => {
    //       console.log('The generic call saveBlockedDatesInCalendar was successful', response);
    //     },
    //     (error) => {
    //       console.log(
    //         'The generic call getProducts was not successful',
    //         error,
    //       );
    //     },
    //     'getProductsV2',
    //     id.EventId,
    //     payload,
    //   );
    // },
  },
  beforeDestroy() {
    this.timeout = false;
  },
};
</script>

<style lang="scss" scoped>
.info-icon:hover{
  color: lightgray;
}
.newFontSize {
  font-size: 100%;
}
.cardTitle {
  text-align: center;
}
.closeEventCard:hover {
  transform: scale(1.2);
}
.subHeader {
  margin: 0px;
  margin-left: 2em;
  font-size: 10px;
}
.options {
  position: relative;
  left: 35px;
}
.viewButton {
  position: relative;
  left: 35px;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid white;
  font-size: 9px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 0px;
  margin-right: 8px;
  position: relative;

  &.with-time {
    width: 30px;
    position: absolute;
    right: 4px;
    margin-right: 0px;
    background-color: #1867c0;
  }
  &.with-time-large {
    position: absolute;
    right: 4px;
    margin-right: 0px;
    background-color: #1867c0;
  }
}
.calendar {
  position: relative;
  height: 300px;
  max-width: 100%;
}
.theme--light.v-sheet {
  background-color: #fff;
  border-color: #fff;
  color: rgba(0,0,0,.87);
  margin-bottom: 0em !important;
}
.panel {
  padding-left: 40px;
  width: 250px;
}
.container {
  padding: 2px 24px 0px 24px !important;
}
.buttonsBD {
  margin-left: 1em;
}
.scrollingPossible {
  overflow-y: auto;
  overflow-x : auto;
  padding-bottom: 1em;
}
</style>

<style lang="scss">
  .v-calendar-daily_head-day-label {
  font-size: 25px !important;
  padding: 0 4px 4px 8px;
  line-height: 40px;
  cursor: pointer;
  }
</style>
